import { render, staticRenderFns } from "./MoleculeEditionAcademyData.vue?vue&type=template&id=1d910012&"
import script from "./MoleculeEditionAcademyData.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports